import { Injectable } from '@angular/core'

import * as moment from 'moment'
moment.locale('fr')

import { BehaviorSubject } from 'rxjs/BehaviorSubject'
import { Observable } from 'rxjs/Observable'

import { Event } from '../models/event.model'

@Injectable()
export class CalendarService {
  private days = []
  private selectedDay: any
  private date

  create (date = null, events: Event[]) {
    this.date = date ? moment.utc(date) : moment.utc()
    const curr = moment.utc(this.date).startOf('month').startOf('week')
    const prevMonth = moment.utc(this.date).startOf('month').subtract(1, 'days')
    const nextMonth = moment.utc(this.date).endOf('month').add(1, 'days')

    // sort events
    events.sort((a,b) => {
      const aDiff = a.endAt.diff(a.beginAt)
      const bDiff = b.endAt.diff(b.beginAt)

      if (aDiff < bDiff) {
        return 1
      } else if (aDiff > bDiff) {
        return -1
      }
      return 0
    })

    // create days
    this.days = []
    this.selectedDay = {}

    // loop the others days
    for (let i = 0; i < 42; i++) {
      // create day
      this.days.push({
        index: i,
        moment: moment(curr),
        eventsByLine: [],
        isNextMonth: curr.isSameOrAfter(nextMonth, 'day'),
        isPrevMonth: curr.isSameOrBefore(prevMonth, 'day')
      })

      // filter previous day events, keeping events for this day, replacing the other with a null
      if (i > 0) {
        this.days[i].eventsByLine = this.days[i - 1].eventsByLine
        .map((ev) => ev && ev.beginAt.isSameOrBefore(curr, 'day') && ev.endAt.isSameOrAfter(curr, 'day') ? ev : null)
      }

      // add new events for this day on null indexes, or at the end
      events
        .filter(ev => this.isCurrentDay(ev, curr) && !this.days[i].eventsByLine.find(e => e === ev))
        .forEach((ev) => {
          const nullIndex = this.days[i].eventsByLine.indexOf(null)
          if (nullIndex === -1) {
            this.days[i].eventsByLine.push(ev)
          } else {
            this.days[i].eventsByLine[nullIndex] = ev
          }
        })

      // save datas if day is selected
      if (curr.isSame(moment.utc(), 'day')) {
        this.selectedDay = this.days[i]
      }

      // increment
      curr.add(1, 'day')
    }

    return {
      month: this.date.format('MMMM'),
      year: this.date.year(),
      table: this.daysToTable(),
      selectedDay: this.selectedDay
    }
  }

  getMonthRange (date = null) {
    const from = date ? moment.utc(date) : moment.utc()
    from.startOf('month').startOf('week')
    return {
      from: from.format('YYYYMMDD'),
      to: from.add(41, 'days').format('YYYYMMDD')
    }
  }

  daysToTable () {
    const table = []
    for (let i = 0; i < 6; i++) {
      table[i] = this.days.slice(i * 7, i * 7 + 7)
    }
    return table
  }

  refreshSelectedDay (index: number) {
    return this.days[index]
  }

  isCurrentDay (event: Event, curr: moment.Moment): boolean {
    const testedBeginAt = event.beginAt.clone()
    const testedEndAt = event.endAt.clone()

    if (event.recurring) {
      testedBeginAt.year(curr.year())
      testedEndAt.year(curr.year())
    }

    return (testedBeginAt.isSameOrBefore(curr, 'day') && testedEndAt.isSameOrAfter(curr, 'day'))
  }
}



// WEBPACK FOOTER //
// ../~/angular2-template-loader!./app/services/calendar.service.ts